// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var Chart = function Chart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.875 2.188a.935.935 0 0 0-.937-.938.935.935 0 0 0-.938.938v13.75a2.81 2.81 0 0 0 2.813 2.812h16.25c.519 0 .937-.418.937-.937a.935.935 0 0 0-.937-.938H2.813a.935.935 0 0 1-.938-.937zm16.602 4.414a.937.937 0 0 0-1.324-1.324l-4.65 4.648L9.419 6.84a.94.94 0 0 0-.664-.274.94.94 0 0 0-.664.274l-3.75 3.75a.937.937 0 0 0 1.324 1.324L8.75 8.828l3.086 3.086a.934.934 0 0 0 1.324 0z"
  }));
};
